import { render, staticRenderFns } from "./ProductID.vue?vue&type=template&id=1e394ea6"
import script from "./ProductID.vue?vue&type=script&lang=js"
export * from "./ProductID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports